export default __webpack_public_path__ + "static/datelabel-dropdown-do-1-light-01c6d7ed9f40ccdfa3066af4620a1109.png";